<ng-container *ngIf="hasHotelPolicies">
  <div class="policiesDetail__policies">
    <div class="policiesDetail__policies-accordion">
      <app-ds-accordion
        [type]="accordionType"
        [size]="accordionSize"
        [initState]="!isUserHistory"
        [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.ROOMS' | transloco">
        <div class="policiesDetail__policies-card">
          <ng-container *ngFor="let room of rooms; index as i">
            @if (roomIndexExists(i + 1)) {
              <div class="policiesDetail__policies-accordion-item-title">
                <app-ds-typography
                  [size]="fontSize.XS"
                  [color]="fontColor.Primary"
                  [fontFamily]="fontFamily.SemiBold"
                  [text]="('BOOKING_MODULE.CHANGE_CANCEL_POLICIES.ROOM' | transloco : { room: i + 1 })">
                </app-ds-typography>
              </div>
              <ng-container *ngFor="let policies of roomCancelationPolicies(i)">
                @if (showCancellationAmount(policies, i)) {
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [color]="fontColor.Primary"
                    [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.ROOM_CANCELATION' | transloco: {
                      hour: getSimpleDate(policies?.DateFromGmtAgency) | date: 'HH:mm',
                      date: getSimpleDate(policies?.DateFromGmtAgency) | date : 'dd/MM/yy',
                      charge: policies?.Amount?.Fare | currencyFormat: policies?.Amount?.CurrencyCode }
                    ">
                  </app-ds-typography>
                  <ng-container *ngIf="policies?.CancellationText">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [color]="fontColor.Primary"
                      [text]="policies?.CancellationText">
                    </app-ds-typography>
                  </ng-container>
                } @else {
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [color]="fontColor.Primary"
                    [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NON_REFUNDABLE' | transloco">
                  </app-ds-typography>
                }
              </ng-container>
            }
          </ng-container>
        </div>
      </app-ds-accordion>
    </div>
  </div>
</ng-container>
